(function () {
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function priceOf(el) {
    // Surcharge in cents, never negative.
    var n = parseInt(el.getAttribute('data-price') || '0', 10);
    if (isNaN(n) || n < 0) n = 0;
    return n;
  }

  function initAddons(container) {
    if (container.dataset.addonsInit === '1') return;
    container.dataset.addonsInit = '1';

    var baseVariantId = container.dataset.baseVariantId;
    var basePrice = parseInt(container.dataset.basePrice || '0', 10);
    var totalEl = container.querySelector('[data-addon-total]');
    var checkboxes = container.querySelectorAll('[data-addon-checkbox]');
    var radios = container.querySelectorAll('[data-addon-radio]');

    var form = container.closest('[data-product-form-wrapper]') || document.querySelector('form[action*="/cart/add"]');
    var addBtn = form ? form.querySelector('[type="submit"], [data-add-to-cart], button[name="add"]') : null;

    // Store the original button HTML so we don't destroy it
    var originalBtnHTML = addBtn ? addBtn.innerHTML : '';

    function selectedRadioPrice() {
      var checked = container.querySelector('[data-addon-radio]:checked');
      return checked ? priceOf(checked) : 0;
    }

    function recalc() {
      var extras = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) extras += priceOf(cb);
      });
      extras += selectedRadioPrice();
      if (totalEl) totalEl.textContent = formatMoney(extras);

      // Update the button price in place using regex on the stored original HTML
      if (addBtn && originalBtnHTML) {
        var finalTotal = basePrice + extras;
        var newHTML = originalBtnHTML.replace(/\$[\d,]+\.\d{2}/, formatMoney(finalTotal));
        addBtn.innerHTML = newHTML;
      }
    }

    checkboxes.forEach(function (cb) { cb.addEventListener('change', recalc); });
    radios.forEach(function (r) { r.addEventListener('change', recalc); });
    recalc();

    if (!form || !addBtn) return;

    addBtn.addEventListener('click', function (e) {
      var selectedIds = [];
      checkboxes.forEach(function (cb) { if (cb.checked) selectedIds.push(cb.value); });
      var checkedRadio = container.querySelector('[data-addon-radio]:checked');
      if (checkedRadio && checkedRadio.value) selectedIds.push(checkedRadio.value);

      // No add-ons selected: let the native form add just the base machine.
      if (selectedIds.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var items = [{ id: parseInt(baseVariantId, 10), quantity: 1 }];
      selectedIds.forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: 1 });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) { console.error('Addon add-to-cart failed:', err); alert('Something went wrong. Please try again.'); });
    }, true);
  }

  function initAll() {
    document.querySelectorAll('[data-product-addons]').forEach(initAddons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();